import type { Translation } from '@ps/web-shared-components';
import type { SVGAttributes } from 'react';
import React from 'react';

import styles from './IconGroupLegend.scss';

export interface IconsLegendData {
  Icon: React.ReactElement<
    SVGAttributes<SVGElement>,
    React.FunctionComponent<SVGAttributes<SVGElement>> & { displayName: string }
  >;
  Description: React.ReactElement<typeof Translation>;
}

interface Props {
  title: React.ReactElement<typeof Translation>;
  data: IconsLegendData[];
}

const IconGroupLegend: React.FC<Props> = ({ data, title }) => (
  <section className={styles.container}>
    <p className={styles.title}>{title}</p>

    {data.map(({ Icon, Description }, index) => (
      <div key={index} className={styles.iconWrap}>
        {Icon} {Description}
      </div>
    ))}
  </section>
);

export default IconGroupLegend;
